module.exports = require('./helpers/bundle-url').getBundleURL('j8FQO') + "logo-dark.eefe0b7f.svg";